import { gql } from '@apollo/client';

export const syncUser = gql`
  mutation syncUser($email: String!, $setPhoneNumber: String) {
    syncUser(email: $email, setPhoneNumber: $setPhoneNumber)
  }
`;
